import React, { useEffect, useRef } from "react";
import { MENUS } from "Common";
import { connect } from "react-redux";
import { setSubMenuDirection } from "actions";
import { HORIZONTAL, VERTICAL } from "constants";
import { STEPS } from "../../config/Common";
import EmailingMenu from "./sub-menu/emailing/EmailingMenu";
import EboxMenu from "./sub-menu/ebox/EboxMenu";
import SmsMenu from "./sub-menu/sms/SmsMenu";
import NotificationMenu from "./sub-menu/notification/NotificationMenu";
import Icon, { ICON_MAPPINGS } from "../ui/Icon";

const SubMenu = ({
  auth,
  settings,
  subMenuDirection,
  step,
  application,
  stickyMenu,
  setSubMenuDirection,
}) => {
  const subMenuRef = useRef(null); // Utilisation de useRef pour créer une référence

  const handleClick = () =>
    setSubMenuDirection(
      subMenuDirection === VERTICAL ? HORIZONTAL : VERTICAL
    );

  useEffect(() => {
    // Utilisez cette référence pour effectuer des actions si nécessaire, comme interagir avec le DOM
    if (subMenuRef.current) {
      // Exemple d'utilisation de subMenuRef
      console.log(subMenuRef.current);
    }
  }, []);

  const {
    loggedAs,
    user,
    preference,
    detached,
  } = auth;

  const menuItems = MENUS[loggedAs];

  if (
    user == null ||
    user.id == null ||
    !loggedAs ||
    loggedAs === "GUEST" ||
    user?.selectedOrganization?.emailingPreferences?.accessType === "UA"
  ) {
    return null;
  }

  let hideMenu =
    [
      STEPS["MANAGE_THEME"],
      STEPS["THEME_PREVIEW"],
      STEPS["SELECT_NEWS"],
      STEPS["MANAGE_TEXT_MODEL"],
      "HIDE_MENU",
    ].indexOf(step) !== -1;
  if (hideMenu) return null;

  const allowEmailCreation =
    loggedAs === "ADMIN" ||
    (loggedAs === "USER" &&
      preference &&
      preference["allowCreateCampaign"] === 1) ||
    detached;

  let menu = (
    <EmailingMenu
      allowCreation={allowEmailCreation}
      items={menuItems}
      allowDashboardPage={settings.enableDashboard}
    />
  );
  let visibleItems = menuItems.length - 4;

  switch (application) {
    case "EBOX":
      menu = <EboxMenu items={menuItems} clients={user.clients} />;
      visibleItems = 1;
      break;
    case "SMS":
      const allowSmsCreation =
        loggedAs === "ADMIN" ||
        (loggedAs === "USER" &&
          preference &&
          preference["allowCreateSms"] === 1);
           console.log(
          "====== SubMenu render: loggedAs",
          allowSmsCreation,
          loggedAs,
          "ADMIN" === loggedAs,
          "USER" === loggedAs &&
            preference &&
            preference["allowCreateSms"] === 1,
        );
      menu = <SmsMenu allowCreation={allowSmsCreation} items={menuItems} />;
      break;
    case "NOTIFICATION":
      menu = <NotificationMenu items={menuItems} />;
      break;
  }

  return (
    <nav
      ref={subMenuRef} // Utilisation de useRef pour la référence
      id="subMenu"
      className={`sub-menu ${
        subMenuDirection === VERTICAL ? "vertical" : ""
      } ${stickyMenu ? "fixed" : ""}`}
    >
      {visibleItems > 0 && (
        <span
          className="flip-menu flex-column-center"
          onClick={handleClick}
        >
          <Icon name={ICON_MAPPINGS["icon-tt-menu"]} size={18} className="icon-tt-menu" />
        </span>
      )}
      {menu}
    </nav>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subMenuDirection: state.params.subMenuDirection,
  step: state.params.step,
  application: state.params.application,
  settings: state.auth.currentSetting,
});

const mapDispatchToProps = (dispatch) => ({
  setSubMenuDirection: (direction) => dispatch(setSubMenuDirection(direction)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubMenu);
